import React, { Children, useMemo } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Collapse from '@material-ui/core/Collapse';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { Chip } from '@material-ui/core';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { PerformanceInsightsTranslationPath } from '../../i18n/PerformanceInsightsLocale';
import { formatNumberWithCommas } from '../../utilities/helpers';

const useRowStyles = makeStyles({
  root: {
    background: '#eef2ff',
    cursor: 'pointer',
    '& > *': {
      borderBottom: 'unset',
      color: '#1d40af',
      fontWeight: 'bold',
      background: 'inherit',
      '& p': {
        fontWeight: 'bold',
      },
    },
  },
  rowBody: {
    '& .MuiTableCell-root': {
      maxWidth: '10px',
    },
    '& .MuiTableCell-head': {
      fontWeight: 'bold',
      color: '#4b5563',
    },
    '& .MuiTableCell-footer': {
      fontWeight: 'bold',
      color: '#4b5563',
    },
  },
  Active: {
    background: '#dcfce7',
  },
  Inactive: {
    background: '#e5e7eb',
  },
});

export default function Row({ row }) {
  const { t } = useTranslation(PerformanceInsightsTranslationPath);
  const [open, setOpen] = React.useState(false);
  const classes = useRowStyles();

  const { unqualifiedLeads, qualifiedLeads } = useMemo(() => {
    return row.campaigns?.reduce(
      (acc, campaign) => {
        acc.unqualifiedLeads += campaign.unqualifiedLeads || 0;
        acc.qualifiedLeads += campaign.qualifiedLeads || 0;
        return acc;
      },
      { unqualifiedLeads: 0, qualifiedLeads: 0 }
    );
  }, [row.campaigns]);

  return (
    <React.Fragment>
      <TableRow className={classes.root} onClick={() => setOpen(!open)}>
        <TableCell component="th" scope="row" colSpan={13} className="">
          <p>
            {t('totals', {
              propertyName: row.propertyName,
              totalLeads: formatNumberWithCommas(row.totalLeadsByProperty),
              qualified: formatNumberWithCommas(qualifiedLeads),
              unqualified: formatNumberWithCommas(unqualifiedLeads),
            })}
          </p>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={13}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Table>
              <TableBody>
                {Children.toArray(
                  row.campaigns?.map((campaign) => (
                    <TableRow className={classes.rowBody}>
                      <TableCell>{campaign.campaignId}</TableCell>
                      <TableCell>
                        {campaign.campaignName}
                        <Chip
                          className={clsx(classes[campaign.status], 'mx-2')}
                          label={campaign.status}
                        />
                      </TableCell>
                      <TableCell>{campaign.platforms}</TableCell>
                      <TableCell>{campaign.mediaDetails || ' '}</TableCell>
                      <TableCell>{formatNumberWithCommas(campaign.activeLeads)}</TableCell>
                      <TableCell>{formatNumberWithCommas(campaign.qualifiedLeads)}</TableCell>
                      <TableCell>{formatNumberWithCommas(campaign.unqualifiedLeads)}</TableCell>
                      <TableCell>{formatNumberWithCommas(campaign.totalLeads)}</TableCell>
                    </TableRow>
                  ))
                )}
              </TableBody>
            </Table>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}